//
//
//
//

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
    components: {
        ClipLoader,
    },
    props: {
        size: { type: String, default: '35px' },
        color: { type: String, default: 'var(--primary-color)' },
    },
}
